/* eslint-disable import/no-cycle */
/* eslint-disable max-classes-per-file */
import { IsString, IsUUID, IsBoolean, IsOptional, ValidateNested, IsNotEmptyObject } from 'class-validator';
import 'reflect-metadata';
import { Type } from 'class-transformer';
import { FunctionalAreaDTO } from './functionalArea';

export class GuideChapterDTO {
  @IsUUID()
  guideChapterId!: string;

  @IsString()
  name!: string;

  @IsUUID()
  functionalAreaId!: string;

  @IsBoolean()
  disabled!: boolean;
}

export class GroupedGuideChapterDTO {
  @ValidateNested()
  @IsNotEmptyObject()
  @Type(() => FunctionalAreaDTO)
  functionalArea!: FunctionalAreaDTO;

  @ValidateNested({ each: true })
  @Type(() => GuideChapterDTO)
  guideChapters!: GuideChapterDTO[];
}

export class GetGuideChapterDTO {
  @IsBoolean()
  @IsOptional()
  includeDisabledChapters?: boolean;

  @IsBoolean()
  @IsOptional()
  includeDisabledFunctionalAreas?: boolean;
}

export class UpdateGuideChapterDTO {
  @IsUUID()
  guideChapterId!: string;

  @IsString()
  @IsOptional()
  name?: string;

  @IsBoolean()
  @IsOptional()
  disabled?: boolean;
}

export class CreateGuideChapterDTO {
  @IsUUID()
  functionalAreaId!: string;

  @IsString()
  name!: string;
}

export class UpdateSortGuideChaptersDTO {
  /**
   * Important: the guideChapterIds have all to be from the same functional area.
   * Else there is no guarantee what happens.
   */
  @IsUUID(undefined, { each: true })
  guideChapterIds!: string[];
}
